import TopPublicationFields from './TopPublicationFields'
import {doLangFields} from '../../lib/ks-tools'
import {setCookie} from "tiny-cookie";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.zen_report.top_publications_table.fields", TopPublicationFields),
            sortOrder: [
                {
                    field: 'countViews',
                    direction: 'desc'
                }
            ],
            additionalActions: [],
        }
    },
    props: {
        base: null
    },
    created() {
        if (this.base !== 'zen') {
            setCookie('engine', 'zen');
            setCookie('dbname', 'zen');
            this.changeDb();
        }
    },
    methods: {
        changeDb() {
            window.location.href = '/' + window.locale + '/changedb/zen' + '?url=' +  window.app_current_page;
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
